
import Scroller from 'vux/src/components/scroller/index.vue'


export default {
components: {
Scroller
},
name: 'lists',
data() {
return {
activetab: '',
widthbox1: 0,
tablist: [
{ name: '课程', enname: 'courses', num: 0 },
{ name: '大讲堂', enname: 'largeclass', num: 13 },
{ name: '以案说法', enname: 'analysis', num: 5 },
{ name: '案例库', enname: 'cases', num: 2 }
],
screenwidth: 0
};
},
methods: {

changetab(e) {
this.activetab = e;
let length = this.tablist.length;
if (e === this.tablist[0].enname) {
document.querySelector('.collection-box1').style.transform =
'translate(0px, 0px) scale(1) translateZ(0px)';
}
if (e === this.tablist[length - 1].enname) {
document.querySelector('.collection-box1').style.transform =
'translateX(' +
(this.screenwidth - this.widthbox1) +
'px) translateY(0px) translateZ(0px) scale(1, 1)';
}
}
},
watch: {},
computed: {

},
created() {
this.activetab = this.tablist[0].enname;
this.screenwidth = document.querySelector('html').clientWidth;
},
mounted() {
var box1s = document.querySelectorAll('.collection-box1item');
var widthbox1 = 0;
box1s.forEach(element => {
widthbox1 += element.clientWidth;
});
this.widthbox1 = widthbox1;
document.querySelector('.collection-box1').style.width =
widthbox1 + 10 + 'px';
}
};
